import { handleTrack } from '../../../../utils/tracker';
import { UpTick } from '../../../Icons';

interface ITEM_PROPS {
  cityName: string;
  isActive: boolean;
  link: string;
  isLastItem: boolean;
}

const Item = ({
  cityName,
  isActive,
  link,
  isLastItem,
}: ITEM_PROPS): JSX.Element => {
  return (
    <div>
      <a
        key={cityName}
        href={link}
        onClick={(e) => {
          handleTrack({
            label: 'lhs_cta',
            obj: e.target,
          });
        }}
      >
        <div className={`${isLastItem ? '' : 'border-b'} p-4 `}>
          <div
            className={`text-s-14 font-medium flex items-center justify-between gap-2 cursor-pointer hover:text-blue-350 hover:underline ${
              isActive ? 'text-blue-350 underline' : 'text-font-500'
            }`}
          >
            {cityName}{' '}
            {isActive ? (
              <UpTick colorCode="#1572ED" className="rotate-90" />
            ) : null}
          </div>
        </div>
      </a>
    </div>
  );
};

export { Item };
